var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-footer-info"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.complaintInfo)}}),_c('br'),_c('span',{domProps:{"textContent":_vm._s(_vm.companyJurAddress)}}),_c('br'),_c('span',{domProps:{"textContent":_vm._s(_vm.companyEmail)}}),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }